import { CardContent, Divider, Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import { MDTypography } from '../../Component/Common/Components/MDTypography';
import Card from '@mui/material/Card';
import { floor } from 'lodash';
import { SkeletonLoading } from '../../Component/Common/SkeletonLoading/SkeletonLoading';
import { SimplePagination } from '../../Component/Common/Pagination/simplePagination';
import { WhatsNew } from '../../Component/Model/Dto/WhatsNew';
import { WhatsNewService } from '../../Component/Api/WhatsNew/WhatsNewService';
import moment from 'moment';
import { MDBox } from '../../Component/Common/Components/MDBox';
import './WhatsNewPage.css';

export const WhatsNewPage = () => {

    const [whatsNewData, setWhatsNewData] = React.useState<WhatsNew.Response[]>([]);
    
    const itemsPerPage = 10;
    const [activePage, setActivePage] = React.useState(1);
    const [isLoading, setIsLoading] = React.useState(false);
    const [countPages, setCountPages] = React.useState(0);

    const indexOfLastWhatsNewPage = activePage * itemsPerPage;
    const indexOfFirstWhatsNewPage = indexOfLastWhatsNewPage - itemsPerPage;

    const currentContentPage = whatsNewData.slice(
        indexOfFirstWhatsNewPage,
        indexOfLastWhatsNewPage
    );

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let response = await WhatsNewService.getAll();
            setWhatsNewData(response.data);
            setCountPages(floor(response.data.length / itemsPerPage, 0));
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    }

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setActivePage(value);
    };

    useEffect(() => {
        fetchData();

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const renderWhatsNew = currentContentPage.map((result, index) => {
        return (
            <>
                <ListItem key={`list-item-${index}`} alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <ListItemText
                        primary={
                            <Grid container alignItems="center" spacing={1} justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="h4" color="primary">{result.heading}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography color="secondary" variant='body2'>{moment(result.releaseDate).format("DD MMMM YYYY")}</Typography>
                                </Grid>
                            </Grid>
                        }
                        secondary={
                            <React.Fragment>
                                <Grid container mt={1}>
                                    <div className='ItemContent'
                                    dangerouslySetInnerHTML={{ __html: result.releaseNoteContent }} />
                                </Grid>
                            </React.Fragment>
                        }
                    />
                </ListItem>
                <Divider variant="inset" component="li" key={`divider-key-${index}`} />
            </>
        );
    });

    const renderContent = () => {
        if (whatsNewData.length > 0) {
            return (
                <>
                    <MDBox style={{ padding: "10px" }}>
                        <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                        Updates
                        </MDTypography>
                    </MDBox>
                    <SimplePagination activePage={activePage} countPages={countPages} handlePageChange={handlePageChange} />
                    <Grid container mt={1} mb={1}>
                        <Grid item xs={12} >
                            <Card>
                                <CardContent>
                                    <List>{renderWhatsNew}</List>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <SimplePagination activePage={activePage} countPages={countPages} handlePageChange={handlePageChange} />
                </>
            )
        }
        else {
            if (isLoading) {
                return <SkeletonLoading formLoading FieldAmount={6} />
            }
            else {
                return (
                    <MDTypography>No Updates to Show</MDTypography>
                )
            }
        }
    }

    return (
        <>
            {renderContent()}
        </>
    )
}
